function SectionTestimonials1() {
    return (
        <>
            <div className="sx-testimonial-bx-1">
                <div className="owl-carousel testimonial-2-wrap owl-btn-vertical-center">
                    {/*One block*/}
                    <div className="item">
                        <div className="testimonial-2  hover-animation-1">
                            <div className="testimonial-text">
                                <span className="testimonial-quote sx-text-primary"><i className="flaticon-quote" /></span>
                                <p>Nullam cursus lacus insr veneni atis estas. Fusceri libero lorem, vehicul ege sapien id, faucibus vulp. Donec ut urna pretiumiss, ferment felis eget, cons exos. In etcou fringil aliber.</p>
                            </div>
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Oliver Eliah	Charlotte</h4>
                                    <span className="testimonial-position">Founder Of Companey</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*One two*/}
                    <div className="item">
                        <div className="testimonial-2  hover-animation-1">
                            <div className="testimonial-text">
                                <span className="testimonial-quote sx-text-primary"><i className="flaticon-quote" /></span>
                                <p>Nullam cursus lacus insr veneni atis estas. Fusceri libero lorem, vehicul ege sapien id, faucibus vulp. Donec ut urna pretiumiss, ferment felis eget, cons exos. In etcou fringil aliber.</p>
                            </div>
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Oliver Eliah	Charlotte</h4>
                                    <span className="testimonial-position">Founder Of Companey</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*One three*/}
                    <div className="item">
                        <div className="testimonial-2  hover-animation-1">
                            <div className="testimonial-text">
                                <span className="testimonial-quote sx-text-primary"><i className="flaticon-quote" /></span>
                                <p>Nullam cursus lacus insr veneni atis estas. Fusceri libero lorem, vehicul ege sapien id, faucibus vulp. Donec ut urna pretiumiss, ferment felis eget, cons exos. In etcou fringil aliber.</p>
                            </div>
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Oliver Eliah	Charlotte</h4>
                                    <span className="testimonial-position">Founder Of Companey</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*One four*/}
                    <div className="item">
                        <div className="testimonial-2  hover-animation-1">
                            <div className="testimonial-text">
                                <span className="testimonial-quote sx-text-primary"><i className="flaticon-quote" /></span>
                                <p>Nullam cursus lacus insr veneni atis estas. Fusceri libero lorem, vehicul ege sapien id, faucibus vulp. Donec ut urna pretiumiss, ferment felis eget, cons exos. In etcou fringil aliber.</p>
                            </div>
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Oliver Eliah	Charlotte</h4>
                                    <span className="testimonial-position">Founder Of Companey</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionTestimonials1;